<template>
  <div class="check-order-page">
    <main class="check-shell">
      <section class="query-panel">
        <div class="brand">配送订单查询</div>
        <h1>查询订单配送信息</h1>
        <div class="query-row">
          <el-input v-model.trim="filters.order_no" clearable placeholder="请输入订单号（精确查询）" />
          <el-input v-model.trim="filters.recipient_phone" clearable placeholder="请输入收件人电话（精确查询）" />
          <el-button type="primary" :loading="loading" @click="search">查询</el-button>
        </div>
      </section>

      <section class="result-panel">
        <el-empty v-if="!loading && searched && !items.length" description="未查询到订单" />
        <el-empty v-else-if="!loading && !searched" description="请输入订单号或收件人电话查询" />
        <div v-else class="order-list">
          <article v-for="item in items" :key="item.id" class="order-item">
            <div class="field">
              <span>订单状态</span>
              <strong>{{ statusText(item.status) }}</strong>
            </div>
            <div class="field">
              <span>订单备注</span>
              <strong>{{ item.order_remark || "-" }}</strong>
            </div>
            <div class="product-list">
              <span>产品明细</span>
              <div v-if="item.product_items && item.product_items.length" class="product-items">
                <div v-for="(product, index) in item.product_items" :key="index" class="product-item">
                  <strong>{{ product.product_name || "-" }}</strong>
                  <em>{{ product.business_type || "-" }}</em>
                  <em>新开户：{{ product.is_new_account ? "是" : "否" }}</em>
                  <em v-if="product.is_new_account">新开号码：{{ product.new_phone || "-" }}</em>
                  <em v-if="product.is_new_account">首充金额：{{ product.first_recharge_amount ?? "-" }}</em>
                </div>
              </div>
              <strong v-else>{{ item.product_name || "-" }}</strong>
            </div>
            <div class="field">
              <span>客户经理</span>
              <strong>{{ item.courier_name || "-" }}</strong>
            </div>
            <div class="field">
              <span>客户经理电话</span>
              <strong>{{ item.courier_phone || "-" }}</strong>
            </div>
            <div class="field">
              <span>售后电话</span>
              <strong>{{ item.sales_phone || "-" }}</strong>
            </div>
            <div class="notice">
              <p>如有任何人向您索要代理费均为诈骗，请您不要轻信，以防上当受骗。</p>
            </div>
          </article>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { fetchPublicOrderById, searchPublicOrders } from "../api/orders";

export default {
  data() {
    return {
      filters: { order_no: "", recipient_phone: "" },
      items: [],
      loading: false,
      searched: false,
    };
  },
  mounted() {
    const code = this.resolveOrderCode();
    if (code) {
      this.fetchById(code);
    }
  },
  watch: {
    "$route.params.code"() {
      const code = this.resolveOrderCode();
      if (code) {
        this.fetchById(code);
      }
    },
  },
  methods: {
    resolveOrderCode() {
      const routeCode = this.$route.params.code;
      if (routeCode) return routeCode;
      const pathMatch = (window.location.pathname || "").match(/^\/checkOrder\/([^/?#]+)/);
      if (pathMatch) return decodeURIComponent(pathMatch[1]);
      const hashMatch = (window.location.hash || "").match(/^#\/checkOrder\/([^/?#]+)/);
      if (hashMatch) return decodeURIComponent(hashMatch[1]);
      return "";
    },
    statusText(value) {
      const map = {
        wait_assign: "待分配",
        wait_delivery: "待配送",
        in_delivery: "配送中",
        pending_review: "待审核",
        completed: "已完成",
        failed: "已失败",
        rescheduled: "已改约",
      };
      return map[value] || value || "-";
    },
    async fetchById(code) {
      this.loading = true;
      this.searched = true;
      try {
        const { data } = await fetchPublicOrderById(code);
        this.items = data.items || [];
      } catch (error) {
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    async search() {
      if (!this.filters.order_no && !this.filters.recipient_phone) {
        this.$message.warning("请输入订单号或收件人电话");
        return;
      }
      this.loading = true;
      this.searched = true;
      try {
        const { data } = await searchPublicOrders({
          order_no: this.filters.order_no || undefined,
          recipient_phone: this.filters.recipient_phone || undefined,
        });
        this.items = data.items || [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.check-order-page {
  min-height: 100vh;
  background: #f6f8fb;
  color: #172033;
}

.check-shell {
  width: min(860px, calc(100% - 32px));
  margin: 0 auto;
  padding: 44px 0;
}

.query-panel,
.result-panel {
  background: #ffffff;
  border: 1px solid #e5e9f2;
  border-radius: 8px;
}

.query-panel {
  padding: 28px;
}

.brand {
  font-size: 14px;
  color: #1f6feb;
  font-weight: 600;
}

h1 {
  margin: 8px 0 24px;
  font-size: 28px;
  font-weight: 700;
}

.query-row {
  display: grid;
  grid-template-columns: 1fr 1fr 120px;
  gap: 12px;
}

.result-panel {
  margin-top: 18px;
  padding: 20px;
}

.order-list {
  display: grid;
  gap: 12px;
}

.order-item {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  padding: 18px;
  border: 1px solid #edf0f5;
  border-radius: 8px;
}

.field span {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  color: #687386;
}

.field strong {
  font-size: 16px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.product-list {
  grid-column: 1 / -1;
}

.product-list > span {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  color: #687386;
}

.product-items {
  display: grid;
  gap: 10px;
}

.product-item {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  padding: 12px;
  background: #f6f8fb;
  border-radius: 8px;
}

.product-item strong {
  width: 100%;
  font-size: 16px;
}

.product-item em {
  color: #526173;
  font-style: normal;
  font-size: 14px;
}

.notice {
  grid-column: 1 / -1;
  padding: 14px;
  background: #fff7e8;
  border: 1px solid #ffd89a;
  border-radius: 8px;
  color: #6d4b12;
  line-height: 1.7;
}

.notice p {
  margin: 0;
}

.notice p + p {
  margin-top: 6px;
}

@media (max-width: 720px) {
  .check-shell {
    width: calc(100% - 24px);
    padding: 24px 0;
  }

  .query-panel {
    padding: 20px;
  }

  .query-row,
  .order-item {
    grid-template-columns: 1fr;
  }
}
</style>
